import Viewer from './Viewer';
import Analytics from './Analytics';
// import UI from './OneRoomUI';
// import Util from './OneRoomUtil';

const Api = {
  Viewer,
  Analytics,
  //	UI,
  //	Util,
};

export default Api;
